import React from 'react';
import classnames from 'classnames';

import styles from './skeleton-loader.module.scss';

const baseClass = 'skeleton-loader';
export type SkeletonLoaderType = {
  className?: string;
  shape: 'rectangle' | 'pill';
  height: string;
  width: string;
  children?: React.ReactNode;
  isLoading: boolean;
  ariaLabel?: string;
};

export const SkeletonLoader: React.FC<SkeletonLoaderType> = ({
  className,
  shape,
  height,
  width,
  children,
  isLoading,
  ariaLabel
}) => {
  const classes = classnames(styles[baseClass], styles[`${baseClass}--${shape}`], className);

  return (
    <div
      className={classes}
      style={{ height: height, width: width }}
      role="alert"
      aria-busy={isLoading}
      aria-label={ariaLabel}
      data-testid="skeleton-loader-component"
    >
      {children}
    </div>
  );
};
